
<aside class="sidebard-bg pull-left show-mobile-menu mobile-menu-asidebar" *ngIf="isAirport">
      <div class="admin-logo pull-left mb-3 mt-3 mobile-partition">
        <img src="assets/image/admin-logo.png" class="img-fluid" />
        
        <button (click)="Mobile_sidebar_menu_btn()" class="mobile-menu-close-btn mobile-menu-btn" style="color: #fff; top: 0px; right: 15px;"><i class="far fa-times-circle" ></i></button>
      
      </div>
  


    <ul class="dashboard-asidebar">
      <li [routerLinkActive]="['active-dashboard']">
        <a  [routerLink]="['/airport-dashboard']"><i class="fas fa-tachometer-alt"></i> Dashboard</a>
      </li>
      <li class="relative-menu">
        <a class="dropDownToggle">
          <i class="fas fa-users"></i> Verify Results
          <i class="fas fa-angle-down" style="margin-left: 5px"></i
        ></a>
        <ul class="dropDownToggle-menu">
          <!-- <li [routerLinkActive]="['active-dashboard']">
            <a  class="responsive-design"  [routerLink]="['/qrcode']"
              ><i class="fas fa-chevron-right"></i> Using QR code</a
            >
          </li> -->
          <li [routerLinkActive]="['active-dashboard']">
            <a  class="responsive-design"  [routerLink]="['/uniqueid']"
              ><i class="fas fa-chevron-right"></i> Using Appointment ID</a
            >
          </li> 
        </ul>
      </li>
      <li [routerLinkActive]="['active-dashboard']">
        <a  class="responsive-design"  [routerLink]="['/airportforgedresults']"><i class="far fa-thumbs-up"></i> Forged Results</a>
      </li>
    </ul>
  </aside>
  